<template>
  <div class="fill-height paper-background photo-exhibition-gallery">
    <transition mode="out-in">
      <div v-if="PhotoExhibition" class="fill-height" key="loaded">
        <transition mode="out-in" :name="currentState === states.gallery ? 'slide-down' : 'slide-up'">
          <v-row  v-if="currentState === states.gallery" key="horizontal" class="fill-height" align="center" justify="center">
            <v-col cols="12">
              <Scribbles />
              <GalleryHorizontalView :elements="processedElements" :artist="artist" :index="index" />
            </v-col>
          </v-row>
          <GalleryGridView :elements="processedElements" v-else-if="currentState === states.grid" key="grid" :two-columns="PhotoExhibition.gridViewTwoRows" @click="onGridViewElementClick" />
        </transition>

        <!-- states switch buttons -->
        <transition>
          <v-btn text small v-if="$vuetify.breakpoint.mdAndUp && currentState === states.gallery" @click="currentState = states.grid" class="mode-switch-btn text-script" key="gotogrid" data-cursor-target="grid|center center">{{states.grid.label}}</v-btn>
          <v-btn text small v-else-if="$vuetify.breakpoint.mdAndUp && currentState === states.grid" @click="currentState = states.gallery" class="mode-switch-btn text-script" key="gotogallery" data-cursor-target="gallery|center center" >{{states.gallery.label}}</v-btn>
        </transition>
        <v-btn text small :to="{name: 'Artists', params: {slug: this.slug}}" class="bottom-center-btn text-script" data-cursor-target="list|center center">Artists</v-btn>
        <v-btn text exact small :to="{name: 'PhotoExhibition', params: {slug: PhotoExhibition._slug}}" class="bottom-left-btn text-script" key="genericback" data-cursor-target="back|center center">Info</v-btn>
      </div>
      <v-row v-else class="fill-height" align="center" justify="center" key="loading">
        <v-col cols="auto" >
          <div class="animated-eye" />
        </v-col>
      </v-row>
    </transition>
  </div>
</template>
<script>
import findIndex from 'lodash/findIndex'
import GetPhotoExhibition from '@/graphql/GetPhotoExhibition.gql'
import GalleryHorizontalView from '@/molecules/GalleryHorizontalView'
import GalleryGridView from '@/molecules/GalleryGridView'
import Scribbles from '@/molecules/Scribbles'
import { optimizedImageURL } from '@/services/OptimizedImage'

const pageStates = {
  gallery: { label: 'Gallery' },
  grid: { label: 'Grid view' }
}

export default {
  name: 'PhotoExhibitionGallery',
  components: {
    GalleryHorizontalView,
    GalleryGridView,
    Scribbles
  },
  data () {
    return {
      states: pageStates,
      currentState: pageStates.gallery
    }
  },
  props: {
    slug: {
      required: true,
      type: String
    },
    artist: {
      required: false,
      type: String
    },
    index: {
      required: false,
      type: String
    }
  },
  methods: {
    onGridViewElementClick (element) {
      this.currentState = this.states.gallery
      console.log(element)
      this.$router.push({ params: { artist: element.photos[0].artist._slug, index: findIndex(this.processedElements, { id: element.id }).toString() } })
    }
  },
  computed: {
    processedElements () {
      if (this.PhotoExhibition.photos) {
        const ret = []
        const regex = /%([0-9])%*./gm

        for (let i = 0; i < this.PhotoExhibition.photos.length; i++) {
          const element = this.PhotoExhibition.photos[i]
          const match = regex.exec(element.details.series)
          if (match) {
            const numPhotos = parseInt(match[1])
            ret.push({
              id: `element-${i}`, // first photo id
              isCollage: true,
              photos: this.PhotoExhibition.photos.slice(i, i + numPhotos)
            })
            i += numPhotos - 1
          } else {
            ret.push({
              id: `element-${i}`,
              isCollage: false,
              photos: [element]
            })
          }
        }
        return ret
      }
      return []
    }
  },
  apollo: {
    PhotoExhibition: {
      query: GetPhotoExhibition,
      variables () {
        return {
          status: 'PUBLISHED',
          slug: this.slug
        }
      }
    }
  },
  metaInfo () {
    if (this.PhotoExhibition) {
      let meta = [
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: `${this.PhotoExhibition.title} | PhotoVogue Festival 2020` },
        { vmid: 'description', name: 'description', content: this.PhotoExhibition.shareDescription },
        { vmid: 'ogdescription', property: 'og:description', content: this.PhotoExhibition.shareDescription }
      ]
      if (this.PhotoExhibition.shareImage) {
        meta = meta.concat([
          { vmid: 'ogimage', property: 'og:image', content: optimizedImageURL(this.PhotoExhibition.shareImage, { width: 1200, height: 625, format: 'jpg', fit: 'crop' }) },
          { vmid: 'ogimagetype', property: 'og:image:type', content: 'image/jpeg' },
          { vmid: 'ogimageheight', property: 'og:image:width', content: '1200' },
          { vmid: 'ogimagewidth', property: 'og:image:height', content: '675' }
        ])
      }
      return {
        // about page browser title
        title: this.PhotoExhibition.title,
        meta
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.mode-switch-btn {
  position: fixed;
  top: 35px;
  left: 50%;
  transform: translateX(-50%);
}

.horizontal-gallery {
  position: relative;
  width: 100%;
  // top: 50%;
  // transform: translateY(-50%);
}

.slide-down-enter-active,
.slide-down-leave-active,
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.25s $ease-in-out-quad, opacity 0.25s $ease-in-out-quad;
}

.slide-up-enter,
.slide-down-leave-to {
  transform: translate3d(0, 30vh, 0);
  opacity: 0;
}

.slide-down-enter,
.slide-up-leave-to {
  transform: translate3d(0, -30vh, 0);
  opacity: 0;
}

</style>
